import {
  useAssignSetting,
  useSetting,
} from "@faire/marketplace-lib/settings/__internal__/useSetting";
import { PRODUCT_TILE_BOOKEND_IMPRESSIONS_250828 } from "@faire/web-api--source/indigofair/settings/PRODUCT_TILE_BOOKEND_IMPRESSIONS_250828";

export const useSettingProductTileBookendImpressionsXP = () =>
  useSetting(PRODUCT_TILE_BOOKEND_IMPRESSIONS_250828, false);

export const useAssignSettingProductTileBookendImpressionsXP = () => {
  const assignSetting = useAssignSetting(
    PRODUCT_TILE_BOOKEND_IMPRESSIONS_250828
  );
  return assignSetting;
};
